import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is CommodityBid and how does it work?",
    a: "CommodityBid is an online tender platform that connects buyers with verified global manufacturers. Instead of traditional ordering, you run live reverse auctions — suppliers compete on price in real time, so you always secure the most competitive deal for your commodity needs.",
  },
  {
    q: "How long does it take to get a quote?",
    a: "Most auctions are scheduled within 24–48 hours of request submission. Once live, they typically conclude in under an hour — meaning you can go from request to signed agreement in just a few business days.",
  },
  {
    q: "Which commodities can I request?",
    a: "You can source across Agriculture (wheat, oil, grains), Metals, Energy, Fresh Food (eggs, dairy), Chemicals, and Construction materials (cement, tiles, steel). If your category isn't listed, our team can custom-organize a dedicated tender for your business.",
  },
  {
    q: "How secure is trading on CommodityBid?",
    a: "Every manufacturer is pre-vetted for quality certifications and production capacity. Payments are held in escrow until goods are verified. Our dispute team mediates issues like quality defects or shipping delays, so your order is protected end to end.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center reveal mb-12">
          <p className="text-xs font-bold text-blue-600 uppercase tracking-widest mb-3">
            Got questions?
          </p>
          <h2
            data-testid="faq-title"
            className="font-display font-black text-3xl md:text-5xl text-slate-900 leading-tight tracking-tight"
          >
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600">
            Everything you need to know about running bids on CommodityBid.
          </p>
        </div>

        <div className="reveal">
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            data-testid="faq-accordion"
            className="space-y-3"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white border border-slate-200/70 rounded-2xl px-5 md:px-6 data-[state=open]:border-blue-300 data-[state=open]:shadow-md transition-all"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-display font-extrabold text-base md:text-lg text-slate-900 text-left hover:no-underline py-5"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-slate-600 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
